import { render, staticRenderFns } from "./freightInfo.vue?vue&type=template&id=048e46ba&scoped=true"
import script from "./freightInfo.vue?vue&type=script&lang=js"
export * from "./freightInfo.vue?vue&type=script&lang=js"
import style0 from "./freightInfo.vue?vue&type=style&index=0&id=048e46ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048e46ba",
  null
  
)

export default component.exports